import React, { useState } from "react";
import Images from "../../../media/images";
// import { public_shareholder } from "../../../pages/servicesForms/BusinessAndCompany/PublicCompanyRegistration/PublicCompanyRegArray";
import { v4 as uuidv4 } from "uuid";
import {ImCross} from "react-icons/im"

const DetailsOfShareHolders = ({
  DetailShareholder,
  setShareHolders,
  needed_share,
  shareHolders,
}) => {
  // const [tableRow, setTableRow] = useState(1);

  // console.log(shareHolders)
  // console.log(DetailShareholder)
  // console.log(needed_share)

  const handleChangeText = (e, item, index) => {
    const { name, value } = e.target;

    let newArr = [...shareHolders];

    if (item.type === "text") {
      newArr[index][name] = value;
      setShareHolders(newArr);
    } else if (item.type === "number") {
      newArr[index][name] = value;
      setShareHolders(newArr);
    } else if (item.type === "date") {
      newArr[index][name] = value;
      setShareHolders(newArr);
    }else if(item.type === "email") {
      newArr[index][name] = value;
      setShareHolders(newArr);
    }
    else {
      // alert('file')
      setShareHolders(newArr);
      // console.log(e.target.files[index])
      // Make new FileReader
      let reader = new FileReader();
      let baseURL = "";
      reader.readAsDataURL(e.target.files[0]);
      // on reader load somthing...
      return new Promise((resolve) => {
        reader.onload = () => {
          // Make a fileInfo Object
          // console.log("Called", reader);
          baseURL = reader.result;
          // baseURL = baseURL.slice(5,baseURL.length)
          // baseURL += "="
          if (item.name === "citizenship") {
            newArr[index].citizenship = baseURL;
          } else if (item.name === "witness_citizenship") {
            newArr[index].witness_citizenship = baseURL;
          } else if (item.name === "passport") {
            newArr[index].passport = baseURL;
          } else if (item.name === "photo") {
            newArr[index].photo = baseURL;
          } else if (item.name === "pp_size_photo") {
            newArr[index].pp_size_photo = baseURL;
          }

          setShareHolders(newArr);
          resolve(baseURL);
        };
      });
    }
  };

  const addItemsToArray = () => {
    // console.log("item");
    const newArr = [...shareHolders];

    newArr.push({
      ...needed_share,
      id: uuidv4(),
    });
    setShareHolders(newArr);
  };

  // console.log('data',datca)
  return (
    <div className="">
      <div className="flex justify-end">
        <img
          onClick={() => {
            // setTableRow(tableRow + 1)
            // setShareHolders(shareHolders => [...shareHolders, needed_share])
            addItemsToArray();
          }}
          src={Images.row_add}
          className="h-10 w-10 cursor-pointer"
          alt=""
          srcSet=""
        />
      </div>
      {/* share holder details form */}
      <div className="flex flex-col">
        <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
            <div className="min-w-[1300px] overflow-x-auto">
              <table id="tbl_posts" className="border-2 border-primary-blue">
                <thead className="border-b-2 border-primary-blue">
                  <tr>
                    {DetailShareholder.map((item, i) => {
                      return (
                        <td
                          key={i}
                          className="border-primary-blue py-3 text-center font-Laila text-primary-red border  text-lg font-bold"
                        >
                          {item.ip1}
                        </td>
                      );
                    })}
                  </tr>
                </thead>
                <tbody id="tbl_posts_body">
                  {shareHolders.map((value, index) => (
                    <tr
                      id="rec-1"
                      className="border-primary-blue border"
                      key={value.id}
                    >
                      <td className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                        {index + 1}

                      </td>

                      {

                        DetailShareholder.map((item, i) => (
                          <React.Fragment key={i}>
                            {/* <td className="p-0" key={i +1}>
                              <input 
                                type="text"
                                placeholder={index+" index"}
                                name={item.name}
                                onChange={(e) => {handleChangeText(e, item, index)}}
                              />
                            </td> */}
                          {i !== 0 && (
                            <td className="p-0 border-r border-primary-blue" key={i + 1}>
                              <input
                                type={item.type}
                                name={item.name}
                                className={`border-primary-blue text-primary-blue m-0  font-Calistoga w-full  py-3 px-3 outline-none  ${item.type==="file"?"file:bg-primary-blue  font-Calistoga outline-none file:text-white file:border-none file:rounded-xl file:text-sm  text-primary-blue rounded-xl ":""}`}
                                id=""
                                onChange={(e) => {
                                  handleChangeText(e, item, index);
                                }}
                              />
                            </td>
                          )}
                        </React.Fragment>
                      ))}

                      <td className="p-0">
                        <div
                          id={index}
                          // console.log(index)
                          onClick={() => {
                            // setTableRow(tableRow - 1);
                            let newArr = [...shareHolders];

                            newArr = newArr.filter(
                              (item) => item.id !== value.id
                            );
                            setShareHolders(newArr);

                            // unregister(`name${index}`)
                            // unregister(`address${index}`)
                          }}
                          className="px-2 text-primary-red"
                        >
                          <ImCross/>
                        </div>
                      </td>

                      {/* <td className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="file"
                          name=""
                          className="border-primary-blue file:bg-primary-blue h-[54px] w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="file"
                          name=""
                          className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                          id=""
                        />
                      </td> */}
                    </tr>
                  ))}
                  {/* <tr className="border-primary-blue border">
                    <td className="col-span-1"></td>
                    <td className="col-span-1"></td>

                    <td className="text-primary-blue col-span-1 border-primary-blue border-r px-10 text-center font-semibold">
                      Total
                    </td>
                    <td className="text-primary-blue border-primary-blue border-r px-10 text-center font-semibold">
                      123
                    </td>
                    <td className="text-primary-blue border-primary-blue border-r px-10 text-center font-semibold">
                      123
                    </td>
                    <td></td>
                    <td></td>
                  </tr> */}
                </tbody>
              </table>
              <div style={{ display: "none" }}>
                {/* table row add */}
                <table id="sample_table">
                  <tbody>
                    <tr id="" className="border-primary-blue border">
                      <td className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                        <span className="sn">1</span>
                      </td>
                      <td className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="file"
                          name=""
                          className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </td>
                      <td className="p-0">
                        <input
                          type="file"
                          name=""
                          className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                          id=""
                        />
                      </td>
                      <td className="">
                        <a href="" className="delete-record">
                          <svg
                            className="text-primary-red h-8 w-8"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            role="img"
                            preserveAspectRatio="xMidYMid meet"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M19.1 4.9C15.2 1 8.8 1 4.9 4.9S1 15.2 4.9 19.1s10.2 3.9 14.1 0s4-10.3.1-14.2zm-4.3 11.3L12 13.4l-2.8 2.8l-1.4-1.4l2.8-2.8l-2.8-2.8l1.4-1.4l2.8 2.8l2.8-2.8l1.4 1.4l-2.8 2.8l2.8 2.8l-1.4 1.4z"
                            />
                          </svg>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsOfShareHolders;
